<template>
  <div
    class="cover-singer-list height-all"
    :class="{
      'cover-singer-list-mobile': createRenderType == 'mobile',
    }"
    :style="{
      '--oneLineCount': renderData.oneLineCount,
    }"
    ref="refCoverListBox"
  >
    <QueryEmptyRetry
      :loading="renderData.initLoading"
      v-if="renderData.loadError || renderData.initLoading"
      @retry="
        () => {
          doRetry(true);
        }
      "
    ></QueryEmptyRetry>
    <PullTo
      v-else
      itemIdField="id"
      :datas="renderData.coverSingData"
      v-model:refreshing="renderData.refreshing"
      v-model:loadingMore="renderData.loadingMore"
      v-model:isLoading="renderData.isLoading"
      v-model:finished="renderData.finished"
      @refresh="doRefresh"
      @loadMore="doLoadMore"
    >
      <template v-slot:customContent>
        <div class="cover-singer-list-item fn-inline">
          <CoverSingerCustom></CoverSingerCustom>
        </div>
        <div
          class="cover-singer-list-item fn-inline"
          v-for="(item, index) in renderData.coverSingData"
          :key="item.id"
        >
          <CoverSingerItem :item="item" :index="index"></CoverSingerItem>
        </div>
      </template>
    </PullTo>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import QueryEmptyRetry from "@/components/basic/pullTo/queryEmptyRetry.vue";
import PullTo from "@/components/basic/pullTo/PullTo.vue";
import CoverSingerCustom from "./coverSingerCustom.vue";
import CoverSingerItem from "./coverSingerItem.vue";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

import useCoverVoiceDataStore from "@/store/editor/coverVoiceDataStore.js";

const coverVoiceDataStore = useCoverVoiceDataStore();

const refCoverListBox = ref(null);

const Router = useRouter();
const route = useRoute();

const props = defineProps({});
const emits = defineEmits([]);
const renderData = reactive({
  refreshing: false,
  loadingMore: false,
  isLoading: false,
  loadError: false,
  finished: false,
  filterParams: {
    query_type: 1,
  },
  initLoading: false,
  coverSingData: [],
  oneItemHeight: 0,
  oneLineCount: 0,
});

const getQueryParams = () => {
  renderData.filterParams = {
    query_type: 1,
  };
  return renderData.filterParams;
};

const doRefresh = (done, errodone) => {
  renderData.isLoading = true;
  coverVoiceDataStore.refresh(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      renderData.loadError = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      errodone(...args);
    }
  );
};

const doLoadMore = (done, errodone) => {
  renderData.isLoading = true;
  coverVoiceDataStore.loadMore(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      errodone(...args);
    }
  );
};

const doRetry = (isRetry) => {
  if (!isRetry) {
    renderData.initLoading = true;
  }
  renderData.isLoading = true;
  coverVoiceDataStore.init(
    getQueryParams(),
    (...args) => {
      renderData.isLoading = false;
      renderData.finished = args[1] ?? true;
      renderData.loadError = false;
      renderData.initLoading = false;
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      renderData.initLoading = false;
    }
  );
  true, isRetry;
};

watch(
  () => coverVoiceDataStore.datas_all,
  (newVal, oldVal) => {
    renderData.coverSingData = coverVoiceDataStore.datas_all;
  }
);

watch(
  () => props.isCurShow,
  (newVal, oldVal) => {
    if (
      props.isCurShow &&
      !coverVoiceDataStore[
        `hasInit_${TabDataSuffixMap[getQueryParams().query_type]}`
      ]
    ) {
      doRetry();
    }
  }
);

const init = (isSelect) => {
  renderData.moodTagValue = coverVoiceDataStore.filterAllData?.moodTagValue;
  renderData.styleTagValue = coverVoiceDataStore.filterAllData?.styleTagValue;
  if (coverVoiceDataStore.datas_all?.length && !isSelect) {
    renderData.coverSingData = coverVoiceDataStore.datas_all;
    renderData.initLoading = false;
  } else {
    doRetry();
  }
};

const onResize = () => {
  const itemRadio = {
    pcWidth: 155,
    h5width: 110,
  };
  const itemMargin = 8;
  const innerWidth = refCoverListBox.value?.offsetWidth;
  if (!innerWidth) {
    return;
  }
  nextTick().then(() => {
    renderData.oneLineCount = Math.floor(
      innerWidth /
        (createRenderType.value == "mobile"
          ? itemRadio.h5width
          : itemRadio.pcWidth)
    );
  });
};

onMounted(() => {
  init();
  onResize();
  renderData.resizeObserver = new ResizeObserver(onResize);
  renderData.resizeObserver?.observe(refCoverListBox.value);
});

onUnmounted(() => {
  renderData.resizeObserver?.disconnect();
});
</script>
<style lang="scss">
.cover-singer-list {
  .cover-singer-list-item {
    width: calc(100% / var(--oneLineCount));
    padding: 0 23px 20px 23px;
    --cover-singer-item-width: 100%;
    .cover-singer-item {
      margin: 0 auto;
    }
  }
  &-mobile {
    .mescroll_feed_list {
      text-align: left;
      padding: 0  6px;
    }
    .cover-singer-list-item {
      padding: 0 10px 20px 10px;
    }
  }
}
</style>
